import React from "react";
import FileUploadButton from "../input";
import PhotoForFileInput from "./PhotoForFileInput";

type Props = {
    value: any;
    onChange: (e: any) => void;
    onImageDelete?: () => void;
    isDisabled?: boolean;
    name?: string;
    hideActions?: boolean;
};

const ImageUploadButton = (props: Props) => {
    const { value, onChange, isDisabled, hideActions = false } = props;
    let src = typeof value == "string" ? value.replaceAll("\\", "/") : value;
    return (
        <>
            <div>
                <FileUploadButton
                    disabled={isDisabled}
                    handleFile={onChange}
                    accept="image/png, image/jpeg"
                    hideActions={hideActions}
                    name={props.name}
                    value={value}
                />
            </div>
            {src && <PhotoForFileInput url={src} />}
        </>
    );
};

export default ImageUploadButton;
